import { tv } from "tailwind-variants";

const styles = tv({
  base: "max-h-[250px] max-w-full rounded sm:shadow-lg",
});

const OnboardingVideo = ({ url }: IMatConfigurationVideoProperty) => {
  const base = styles();

  return (
    <video
      data-testid="onboarding-video"
      className={base}
      autoPlay
      controls
      loop
      muted>
      <source src={url} type="video/mp4" />
    </video>
  );
};

export default OnboardingVideo;
